module.exports = __webpack_public_path__ + "img/logo-yellow.51104f76.png";